import { LoyaltySpecResponseType } from '../loyalty-domain.type';

export const loyaltySpecs: LoyaltySpecResponseType = {
  merchantId: '7f3ffb13-7c1c-4909-9efb-b067b1728f12',
  clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
  awardPointsAsPending: true,
  awardPointsForGiftCardTransaction: true,
  allowReturnsAfterConfirmationPeriod: true,
  confirmationPeriod: 0,
  expiryPeriod: 1,
  defaultPointsAwardRatio: 1,
  expiryMode: 'NoExpiry',
  dynamicPointsAwardRatio: {
    MONDAY: [{ pointsAwardRatio: 2, startTime: '14:32', endTime: '15:43' }],
  },
  dynamicPointsAwardRatioEnabled: true,
  segments: [
    {
      segmentId: 'Whale Id',
      segmentName: 'Whale',
      points: 5,
    },
    {
      segmentId: 'Pizza Lover Id',
      segmentName: 'Pizza Lover',
      points: 2,
    },
  ],
  excludedProducts: [
    {
      type: 'ITEM',
      internalId: null,
      externalId: 'item3.1',
      displayInfoTitlesList: ['DI Item Title 3.1'],
    },
    {
      type: 'GROUP',
      internalId: null,
      externalId: 'group3.1',
      displayInfoTitlesList: ['DI Group Title 3.1'],
    },
  ],
};

export const loyaltyHistory = {
  paging: {
    total: 1,
    count: 10,
    totalPages: 1,
    currentPage: 0,
  },
  loyaltyHistories: [
    {
      loyaltyTransactionStatus: 'CONFIRMED',
      description: 'test',
      originalPoints: 1,
      currentPoints: 1,
      transactionDate: '2023-07-04T16:23:12',
      loyaltyAccountId: 'ab764725-4386-4201-ae85-01ae7caf3b27',
      loyaltyTransactionId: 'ebf349d9-3d60-4f14-8f47-69a215c6f09b',
      status: 'CONFIRMED',
      confirmationDate: '2023-07-04',
    },
    {
      loyaltyTransactionStatus: 'CONFIRMED',
      description: 'test',
      originalPoints: 1,
      currentPoints: 1,
      transactionDate: '2023-07-04T16:23:12',
      loyaltyAccountId: 'ab764725-4386-4201-ae85-01ae7caf3b27',
      loyaltyTransactionId: 'ebf349d9-3d60-4f14-8f47-69a215c6f09c',
      status: 'PENDING',
      confirmationDate: '2023-07-04',
    },
    {
      loyaltyTransactionStatus: 'CONFIRMED',
      description: 'test',
      originalPoints: 1,
      currentPoints: 1,
      transactionDate: '2023-07-04T16:23:12',
      loyaltyAccountId: 'ab764725-4386-4201-ae85-01ae7caf3b27',
      loyaltyTransactionId: 'ebf349d9-3d60-4f14-8f47-69a215c6f09d',
      status: 'EXPIRED',
      confirmationDate: '2023-07-04',
    },
  ],
};

export const redeemPoints = {
  loyaltyTransactionId: '40ee5bca-fc5d-41ac-a3a1-77f1b2ba4820',
  loyaltyStatus: 'SUCCESS',
  externalStatuses: null,
};

export const accountLoyaltyHistory = {
  loyaltyAccountId: '2664f981-a17b-47c9-97b6-1750bd2bbf61',
  loyaltyTierId: null,
  externalId: '',
  loyaltyCardId: null,
  confirmedPoints: 52,
  pendingPoints: 0,
  confirmedBalance: null,
  pendingBalance: null,
  createdDate: '2023-07-04T08:30:50',
  currentLoyaltyTier: null,
  nextLoyaltyTier: null,
  numOfTypeRequiredForNextTier: null,
  tierBasedOnType: null,
  currentLoyaltyTierBasedValue: null,
};
